import { useMemo, useState } from "react";
import { X } from "lucide-react";
import { Reveal } from "../components/common/Reveal";
import { galleryCategories, galleryItems } from "../data/siteData";

export default function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [activeImage, setActiveImage] = useState(null);

  const filteredItems = useMemo(() => {
    if (activeCategory === "All") {
      return galleryItems;
    }
    return galleryItems.filter((item) => item.category === activeCategory);
  }, [activeCategory]);

  return (
    <div data-testid="gallery-page" className="page-shell page-offset">
      <Reveal>
        <section data-testid="gallery-header-section" className="section-block">
          <div className="container-shell">
            <p data-testid="gallery-eyebrow" className="eyebrow">Industrial Portfolio</p>
            <h1 data-testid="gallery-heading" className="section-title">Curated steel fabrication and installation work across Texas sectors.</h1>
            <p data-testid="gallery-description" className="section-paragraph">
              Explore structural framing, fabrication details, and installation moments captured across commercial and industrial programs.
            </p>
            <div data-testid="gallery-filter-group" className="filter-row">
              {galleryCategories.map((category) => (
                <button
                  key={category}
                  type="button"
                  data-testid={`gallery-filter-${category.toLowerCase().replace(/\s+/g, "-").replace(/&/g, "and")}`}
                  className={`filter-chip ${activeCategory === category ? "is-active" : ""}`}
                  onClick={() => setActiveCategory(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>
      </Reveal>

      <section data-testid="gallery-grid-section" className="section-block pt-0">
        <div className="container-shell">
          <div data-testid="gallery-masonry-grid" className="masonry-grid">
            {filteredItems.map((item, index) => (
              <button
                key={`${item.title}-${index}`}
                type="button"
                data-testid={`gallery-item-${index + 1}`}
                className="masonry-item"
                onClick={() => setActiveImage(item)}
              >
                <img data-testid={`gallery-item-image-${index + 1}`} src={item.image} alt={item.title} className="masonry-image" />
                <span data-testid={`gallery-item-title-${index + 1}`} className="masonry-label">
                  {item.title}
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {activeImage && (
        <div data-testid="gallery-lightbox" className="lightbox-overlay" role="dialog" aria-modal="true">
          <div className="lightbox-frame">
            <button
              type="button"
              data-testid="gallery-lightbox-close-button"
              className="lightbox-close"
              onClick={() => setActiveImage(null)}
              aria-label="Close image preview"
            >
              <X size={20} />
            </button>
            <img data-testid="gallery-lightbox-image" src={activeImage.image} alt={activeImage.title} className="lightbox-image" />
            <p data-testid="gallery-lightbox-title" className="lightbox-title">{activeImage.title}</p>
            <p data-testid="gallery-lightbox-category" className="lightbox-subtitle">{activeImage.category}</p>
          </div>
        </div>
      )}
    </div>
  );
}
